/* eslint-disable jsx-a11y/label-has-associated-control */
import { Modal } from '@ctsu/react-ctsu-ui';
import React, { useRef, useState } from 'react';
import { format } from 'date-fns';
import text from "protocol-setup/constants/text";
import PSRForm from './FormToggle';


const SelectPSRChange = ({ setSelectedPSRChangeType, displayCopy }) => {
  return (
    <div>
      <div className="mb-6 d-flex justify-content-center">
         {text.regulatory.psrModal.selectUpdateType}
      </div>
      <div className="row mt-2 d-flex justify-content-center">
        {displayCopy && (
          <button
          type="button"
          className="btn"
          title={text.regulatory.psrModal.buttons.changeExisting.title}
          data-id="SAVE_CHANGES_BUTTON"
          onClick={() => setSelectedPSRChangeType('copy')}
        >
          {text.regulatory.psrModal.buttons.changeExisting.label}
        </button>
      )}
        <button
          type="button"
          className="btn mr-2 ml-2"
          title={text.regulatory.psrModal.buttons.newPsr.title}
          data-id="SAVE_CHANGES_BUTTON"
          onClick={() => setSelectedPSRChangeType('newPSR')}
        >
          {text.regulatory.psrModal.buttons.newPsr.label}
        </button>
      </div>
    </div>
  )
}


const PSRModal = ({ psrList, onAddPSR }) => {
  const [openModal, setModal] = useState(false);
  const [selectedPSRChangeType, setSelectedPSRChangeType] = useState("");
  const [modalTitle, setModalTitle] = useState(text.regulatory.psrModal.titles.addPsr);
  const returnBtnRef = useRef(null)
  const today = format(new Date(), "dd-MMM-yyyy");

  const handleSelectPSRChangeType = (type) => {
    setSelectedPSRChangeType(type);
    setModalTitle(type === "newPSR" ? text.regulatory.psrModal.titles.newPsr : text.regulatory.psrModal.titles.changeExisting);
  };

  const handleCloseModal = () => {

    setSelectedPSRChangeType("");
    setModalTitle(text.regulatory.psrModal.titles.addPsr);
    setModal(false);
    setTimeout(() => {
      returnBtnRef.current.focus();
    }, 0);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setModal(!openModal)}
        className="btn "
        title={text.regulatory.psrModal.buttons.addPsr.title}
        ref={returnBtnRef}
      >
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="plus"
          className="svg-inline--fa fa-plus fa-w-14 ml-n1"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path
            fill="currentColor"
            d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
          ></path>
        </svg>
        PSR
      </button>
      {openModal && (
        <Modal
          id="Protocol_Setup_Request"
          modalTitle={modalTitle}
          onClose={() => handleCloseModal()}
          showCloseBtn={!selectedPSRChangeType}
          buttonText={text.regulatory.psrModal.buttons.cancel}
          modalMaxHeight
        >
          {selectedPSRChangeType ? (
            <PSRForm
              selectedPSRChangeType={selectedPSRChangeType}
              psrList={psrList}
              onAddPSR={onAddPSR}
              onClose={() => handleCloseModal()}
              today={today}
              setModalTitle={setModalTitle}
            />
          ) : (
            <SelectPSRChange
              setSelectedPSRChangeType={handleSelectPSRChangeType}
              displayCopy={psrList?.length > 0}
            />
          )}
        </Modal>
      )}
    </>
  );
};

export default PSRModal;
